export const getOpenOrderBarHeight = element => {
  if (!element || typeof element.getBoundingClientRect !== 'function') {
    return 0;
  }

  const rawHeight = Number(element.getBoundingClientRect().height);
  if (!Number.isFinite(rawHeight) || rawHeight <= 0) {
    return 0;
  }

  return Math.ceil(rawHeight);
};
